import React, { useEffect, useRef, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";

const AnalyticsProductBarChart = ({ dataset, emptyMessage }) => {
  const wrapRef = useRef(null);
  const [chartWidth, setChartWidth] = useState(0);
  const hasData = dataset?.length > 0;

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return undefined;

    const updateWidth = () => {
      setChartWidth(Math.max(el.offsetWidth, 320));
    };

    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasData]);

  if (!hasData) {
    return (
      <div className="aa-chart-card aa-chart-card--wide">
        <div className="aa-chart-card__head">
          <h3>Product groups by volume</h3>
          <p>Line items per product group</p>
        </div>
        <div className="aa-chart-card__empty">{emptyMessage || "No data"}</div>
      </div>
    );
  }

  return (
    <div className="aa-chart-card aa-chart-card--wide">
      <div className="aa-chart-card__head">
        <h3>Product groups by volume</h3>
        <p>Line items per product group</p>
      </div>
      <div ref={wrapRef} className="aa-chart-card__bar-wrap aa-chart-card__bar-wrap--full">
        {chartWidth > 0 ? (
          <BarChart
            width={chartWidth}
            height={Math.max(280, dataset.length * 48)}
            margin={{ left: 8, right: 24, top: 16, bottom: 24 }}
            dataset={dataset}
            layout="horizontal"
            yAxis={[
              {
                scaleType: "band",
                dataKey: "productGroup",
                tickLabelStyle: { fontSize: 12 },
              },
            ]}
            xAxis={[
              {
                label: "Line items",
                tickLabelStyle: { fontSize: 11 },
              },
            ]}
            series={[
              {
                dataKey: "orders",
                label: "Line items",
                color: "#f97316",
              },
            ]}
            grid={{ vertical: true }}
            slotProps={{
              legend: { hidden: true },
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default AnalyticsProductBarChart;
